<template>
  <div class="content-grid">
    <div
      :style="articleImageStyle"
      class="content-grid__background"
    />
    <div
      v-if="content.priority === 'high'"
      class="content-grid__priority"
    >!</div>
    <post-link
      :post="content"
      class="content-grid__title h3"
    >
      {{ content.title }}
    </post-link>
    <div class="content-grid__footer">
      <div class="content-grid__footer-left">
        <ul class="content-grid__meta">
          <li class="content-grid__meta-item">
            <span class="fa fa-comments" />
            {{ content.commentsCount }}
          </li>
          <li class="content-grid__meta-item">
            <span class="fa fa-eye" />
            {{ content.views }}
          </li>
        </ul>
      </div>
      <div class="content-grid__footer-right">
        <div
          class="content-grid__settings"
        >
          <dropdown-input
            :options="dropdownOptions"
            position="right"
            @select="handleDropdownSelect"
          >
            <button>
              <span class="fa fa-ellipsis-h" />
            </button>
          </dropdown-input>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import isBlank from 'is-blank'
import { mapActions } from 'vuex'
import FormMixin from '@/mixins/forms/Form'
import PostLink from '@/components/posts/PostLink'

export default {
  name: 'PostGrid',
  mixins: [FormMixin],
  components: {
    PostLink
  },
  props: {
    content: {
      type: Object,
      required: true
    }
  },
  computed: {
    contentId () {
      return this.content.id
    },
    articleImageStyle () {
      const imageAttachments = this.imageAttachments(this.content)
      const backgroundImage = imageAttachments &&
        imageAttachments[0] &&
        imageAttachments[0].url

      return {
        backgroundImage: `url('${backgroundImage}')`
      }
    },
    dropdownOptions () {
      return [
        { label: 'Bearbeiten', value: 'edit', icon: 'edit' },
        { label: 'Kopieren', value: 'copy', icon: 'copy' },
        { label: 'Löschen', value: 'delete', icon: 'trash' }
      ]
    }
  },
  methods: {
    ...mapActions({
      fetchContentsForFolder: 'contents/fetchForFolder',
      openContentModalContent: 'openContentModalContent',
      openContentCopyModal: 'openContentCopyModal',
      openConfirmModal: 'openConfirmModal',
      closeConfirmModal:'closeConfirmModal',
      setContents: 'contents/apply',
      destroyContent: 'destroyContent'
    }),

    imageAttachments (content) {
      if (content && !isBlank(content.attachments)) {
        return content.attachments.filter(d => d.contentType.startsWith('image/'))
      }
    },
    handleDropdownSelect ({ value }) {
      switch (value) {
        case 'edit':
          this.openContentModalContent(this.content.id)
          break
        case 'copy':
          this.openContentCopyModal(this.content.id)
          break
        case 'delete':
          this.openConfirmModal({
            title: 'Artikel löschen',
            message: `Den Artikel ${this.content.title} wirklich löschen?`,
            callback: () => {
              this.destroyContent(this.content.id)
                .then(() => {
                  this.fetchContentsForFolder(this.$route.params.folderId)
                    .then((response) => {
                      this.setContents(response)
                      this.$emit('loadingDone')
                    })
                })
                .then(this.closeConfirmModal)
            }
          })
          break
        default:
          window.alert(`action: ${value}`)
      }
    }
  }
}
</script>

<style lang="sass">
@import "~styles/imports"

.content-grid
  position: relative
  display: flex
  justify-content: space-between
  flex-direction: column
  height: rem-calc(300)
  padding: rem-calc(40)
  margin: rem-calc($grid-gutter-width-half 0)
  color: $color-white
  background: $color-black

  &__background
    position: absolute
    top: 0
    right: 0
    bottom: 0
    left: 0
    background-color: var(--contentItemBackground)
    background-size: cover
    &::before
      position: absolute
      top: 0
      right: 0
      bottom: 0
      left: 0
      display: block
      content: ""
      background-color: rgba(0, 0, 0, .66)

  &__priority
    width: 30px
    height: 30px
    background: $color-error
    border-radius: 50%
    border: 3px solid #fff
    position: absolute
    top: -10px
    right: -10px
    text-align: center
    font-size: 15px
    font-weight: 900

  &__title
    position: relative
    height: 100%
    margin: 0
    overflow: hidden
    overflow-y: -webkit-paged-x
    color: $color-white
    font-weight: 800

    &:hover,
    &:focus
      text-decoration: none

  &__meta
    &-item
      +font-size(14, 18)
      display: inline-block
      margin-right: rem-calc(10)
      color: $color-white

    &-item + &-item
      border-left: 1px solid rgba($color-grey-1, .25)
      padding-left: rem-calc(10)

  &__footer
    @include font-size(14, 14)

    position: relative
    display: flex
    justify-content: space-between
    align-items: baseline
    flex-direction: row
    margin-top: 1rem
    font-weight: 500

    .fa
      margin-right: rem-calc(5)

    &-left
      float: left

    &-right
      float: right

  &__settings
    position: relative

    button
      +font-size(17, 17)

      color: $color-white

  &__background-image
    background-size: cover
    background-position: center
    position: absolute
    top: 0
    left: 0
    right: 0
    bottom: 0
    opacity: 0.25

  &__new
    background: $color-error
    border-radius: rem-calc(100)
    border: 2px solid $color-white
    bottom: calc(100% - 6px)
    height: rem-calc(12)
    left: calc(100% - 6px)
    position: absolute
    width: rem-calc(12)

    &.tooltip
      position: absolute
</style>





// WEBPACK FOOTER //
// src/components/posts/PostGrid.vue